import { optimizeUnsplashUrl } from "../utils/imageOptimizer";

export const facultiesdata = {
  engineering: {
    name: "Engineering",
    welcome:
      "Welcome to the Faculty of Engineering, where creativity meets technical expertise to solve real-world challenges through innovative engineering solutions.",
    about:
      "The Faculty of Engineering is committed to providing cutting-edge programmes in engineering, focusing on practical applications & the latest technological advances. Our programmes are designed to meet the increasing demand for skilled engineers in fields like cybersecurity, cloud computing, & front-end/back-end engineering. Students will gain hands-on experience & critical problem-solving skills, preparing them to tackle the challenges of today’s rapidly evolving tech landscape.",
    shortdescription: "Shape the business leaders of tomorrow.",
    icon: "fas fa-cogs",

    image: optimizeUnsplashUrl(
      "https://images.unsplash.com/photo-1541888946425-d81bb19240f5",
      800,
      80
    ),
    programmes: [
      {
        category: "Undergraduate",
        items: [
          {
            name: "Undergraduate Diploma in Engineering",
            link: "/pagenotopenyet",
            pofstudyimg:
              "/image-fix/faculties-message/faculty-of-leadership.jpeg",
          },
          {
            name: "Undergraduate Certificate in Front-End Engineering",
            link: "/pagenotopenyet",
            pofstudyimg: "/image-fix/faculties-message/22l.png",
          },
          {
            name: "Undergraduate Certificate in Back-End Engineering",
            link: "/pagenotopenyet",
            pofstudyimg: "/image-fix/faculties-message/faculty-img1.jpeg",
          },
          {
            name: "Undergraduate Certificate in Cloud Engineering",
            link: "/pagenotopenyet",
            pofstudyimg: "/image-fix/faculties-message/faculty-img2.jpeg",
          },
          {
            name: "Undergraduate Certificate in Cybersecurity",
            link: "/pagenotopenyet",
            pofstudyimg: "/image-fix/faculties-message/faculty-img3.jpeg",
          },
        ],
      },
    ],
    closingHead: "Your Path to Engineering Excellence Starts Here",
    closingBottom:
      "Engineering is at the heart of the innovations shaping tomorrow’s world. Whether you're looking to specialise in cybersecurity, cloud computing, or front-end engineering, our programmes will give you the hands-on experience & technical knowledge needed to succeed. Our industry-focused curriculum ensures that you’re always at the forefront of technology, ready to tackle real-world engineering challenges. Get started today—become a leader in engineering innovation!",
    youtubelink:
      "https://www.youtube.com/embed/BgdE65SZ1SU?start=90&autoplay=1&mute=1&controls=1&modestbranding=1&rel=0",
    bottombgimage: "/image-fix/faculties-message/eingeneering-image.jpeg",
    welcometxtbgimage: "/image-fix/faculties-message/faculty-img4.jpeg",
  },

  "international-relations-diplomacy": {
    name: "International Relations, Diplomacy & Politics",
    welcome:
      "Welcome to the Faculty of Diplomacy, International Relations, & Politics where future diplomats, politicians, international leaders, & global professionals shape their careers.",
    about:
      "Our Faculty offers a comprehensive range of programmes in Diplomacy, Politics & International Relations, carefully crafted to meet the demands of a dynamic, interconnected world. Our curriculum blends academic rigor with practical skills, ensuring students gain critical insights into international affairs, global policies, political systems, governance, public policy, & diplomatic strategies. From negotiation techniques to understanding international law, our programmes equip students with the expertise needed to excel in the global arena.",
    // Optimized
    image: optimizeUnsplashUrl(
      "https://images.unsplash.com/photo-1607778102165-6a418ee9adf2",
      800,
      80
    ),
    shortdescription: "Build the future with innovative engineering.",
    icon: "fas fa-globe",

    programmes: [
      {
        category: "Undergraduate",
        items: [
          {
            name: "Undergraduate Certificate/Diploma in Diplomacy & Politics",
            link: "/pagenotopenyet",
            pofstudyimg:
              "/image-fix/faculties-message/faculty-of-cs-image.jpeg",
          },
        ],
      },
      {
        category: "Postgraduate",
        items: [
          {
            name: "Postgraduate Diploma in Diplomacy & Politics",
            link: "/pagenotopenyet",
            pofstudyimg:
              "/image-fix/faculties-message/faculty-of-diplomacy.jpeg",
          },
        ],
      },
      {
        category: "Master’s",
        items: [
          {
            name: "Master of Arts in Diplomacy & International Relations",
            link: "/pagenotopenyet",
            pofstudyimg:
              "/image-fix/faculties-message/faculty-of-leadership.jpeg",
          },
        ],
      },
      {
        category: "Executive Education",
        items: [
          {
            name: "Advanced International Relations & Diplomatic Practice Course",
            link: "/executive/advanced-international-relations",
            pofstudyimg: "/image-fix/faculties-message/22l.png",
          },
          {
            name: "The Young Politician Course",
            link: "/executive/emerging-politician",
            pofstudyimg: "/image-fix/faculties-message/eingeneering-image.jpeg",
          },
        ],
      },
    ],

    closingHead: "Take the First Step Towards a Global Career",
    closingBottom:
      "Embark on a transformative journey in Diplomacy, International Relations, & Politics. Our comprehensive programmes equip you with the skills, knowledge, & networks to thrive in the global arena. Whether you aim to shape international policies, engage in diplomacy, or lead in political spheres, our courses empower you to make a difference. Join a global community of aspiring leaders, gain practical insights, & build the foundation for a successful & impactful career. Apply now & connect with industry leaders to influence the world. Your journey to global leadership & political excellence starts here!",
    youtubelink:
      "https://www.youtube.com/embed/BgdE65SZ1SU?start=90&autoplay=1&mute=1&controls=1&modestbranding=1&rel=0",
    bottombgimage: "/image-fix/faculties-message/faculty-of-diplomacy.jpeg",
    welcometxtbgimage: "/image-fix/faculties-message/faculty-img3.jpeg",
  },

  "computer-science": {
    name: "Computer Science",
    welcome:
      "Welcome to the Faculty of Computer Science, where technology meets creativity to build the digital world of tomorrow.",
    about:
      "Our Faculty offers forward-thinking programmes in computer science, designed to keep pace with the ever-evolving tech industry. Whether you’re looking to specialise in data analysis or pursue a degree in computer science, our courses combine theoretical knowledge with practical application. These programmes equip students with the necessary skills to develop software, analyse data, & drive technological innovation in a variety of industries.",

    shortdescription: "Caring for the health & well-being of society.",
    icon: "fas fa-laptop-code",
    // Optimized
    image: optimizeUnsplashUrl(
      "https://images.unsplash.com/photo-1743862558324-64de6d680fbb",
      800,
      80
    ),
    programmes: [
      {
        category: "Undergraduate",
        items: [
          {
            name: "BSc Computer Science",
            // link: "/apply/bsc-computer-science",
            link: "/pagenotopenyet",
            pofstudyimg: "/image-fix/faculties-message/faculty-img1.jpeg",
          },
        ],
      },
      {
        category: "Postgraduate",
        items: [
          {
            name: "Postgraduate Data Analysis Diploma Programme",
            // link: "/apply/postgraduate-data-analysis-diploma",
            link: "/pagenotopenyet",
            pofstudyimg: "/image-fix/faculties-message/faculty-img2.jpeg",
          },
        ],
      },
      {
        category: "Certified",
        items: [
          {
            name: "Certified Data Analyst Programme",
            // link: "/apply/certified-data-analyst",
            link: "/pagenotopenyet",
            pofstudyimg: "/image-fix/faculties-message/faculty-img3.jpeg",
          },
        ],
      },
    ],
    closingHead: "Join the Future of Tech Innovation",
    closingBottom:
      "In a world driven by technology, there’s no better time to pursue a career in computer science. Our comprehensive programmes are designed to provide you with the technical expertise & problem-solving skills needed to excel in the digital landscape. Whether your interest lies in software development, data analysis, or other tech fields, we provide the tools you need to succeed. Join us & prepare to lead the charge in digital transformation. Apply now & become a key player in the future of technology!",
    youtubelink:
      "https://www.youtube.com/embed/BgdE65SZ1SU?start=90&autoplay=1&mute=1&controls=1&modestbranding=1&rel=0",
    bottombgimage: "/image-fix/faculties-message/faculty-of-cs-image.jpeg",
    welcometxtbgimage: "/image-fix/faculties-message/faculty-img1.jpeg",
  },

  "business-leadership": {
    name: "Business & Leadership",
    welcome:
      "Welcome to the Faculty of Business & Leadership, where innovation meets leadership to shape the future of business professionals.",
    about:
      "Our Faculty offers a wide array of business & leadership programmes designed to meet the demands of today’s dynamic work environment. The courses incorporate cutting-edge practices in leadership, consulting, project management, & entrepreneurship. With a focus on practical knowledge, leadership skills, & global business perspectives, our programmes aim to nurture innovative leaders capable of solving complex business challenges. Designed for professionals at all career stages, our offerings also include gender leadership & agile thinking to equip you with the skills to lead across industries.",

    shortdescription: "Caring for the health & well-being of society.",
    icon: "fas fa-briefcase",
    image: optimizeUnsplashUrl(
      "https://images.unsplash.com/photo-1542744173-8e7e53415bb0",
      800,
      80
    ),
    programmes: [
      {
        category: "Undergraduate",
        items: [
          {
            name: "BSc in Business Administration",
            // link: "/bachelors/administration",
            link: "/pagenotopenyet",
            pofstudyimg: "/image-fix/faculties-message/faculty-img4.jpeg",
          },
          {
            name: "Undergraduate Certificate/Diploma in Management & Entrepreneurship",
            // link: "/apply/certificate-management-entrepreneurship",
            link: "/pagenotopenyet",
            pofstudyimg:
              "/image-fix/faculties-message/faculty-of-cs-image.jpeg",
          },
        ],
      },
      {
        category: "Postgraduate",
        items: [
          {
            name: "Postgraduate Certificate In Global Businesss And Strategic Leadership",
            // link: "/apply/postgraduate-creative-leadership",
            link: "/masters/leadership",
            pofstudyimg:
              "/image-fix/faculties-message/faculty-of-diplomacy.jpeg",
          },
          {
            name: "Postgraduate Diploma In Global Businesss And Strategic Leadership",
            // link: "/apply/postgraduate-creative-leadership",
            link: "/masters/leadership",
            pofstudyimg:
              "/image-fix/faculties-message/faculty-of-leadership.jpeg",
          },
          {
            name: "Postgraduate Certificate/Diploma in Executive Professional Consulting",
            link: "/pagenotopenyet",
            pofstudyimg:
              "/image-fix/faculties-message/faculty-of-leadership.jpeg",
          },
        ],
      },
      {
        category: "Master’s",
        items: [
          {
            name: "Master of Arts in Global Business & Strategic Leadership",
            link: "/masters/leadership",
            pofstudyimg: "/image-fix/faculties-message/22l.png",
          },
          {
            name: "Master of Arts in Women’s & Gender Leadership Studies",
            // link: "/apply/ma-womens-gender-leadership",
            link: "/pagenotopenyet",
            pofstudyimg: "/image-fix/faculties-message/eingeneering-image.jpeg",
          },
        ],
      },
      {
        category: "Executive Education",
        items: [
          {
            name: "The Young Emerging Entrepreneur Course",
            link: "/executive/young-emerging-entrepreneur",
            pofstudyimg: "/image-fix/faculties-message/faculty-img1.jpeg",
          },
          {
            name: "The Emerging Journalist Course",
            link: "/executive/emerging-journalist",
            pofstudyimg: "/image-fix/faculties-message/faculty-img2.jpeg",
          },
        ],
      },
    ],
    closingHead: "Elevate Your Career with Transformational Leadership",
    closingBottom:
      "Are you ready to take your career to the next level? Our Business & Leadership programmes offer the essential tools, strategies, & expertise to thrive in today’s competitive business landscape. Whether you are looking to become a creative entrepreneur, a transformative leader, or a consultant who drives change, we provide a comprehensive education designed to meet your professional needs. With cutting-edge content & practical experience, you’ll emerge as a leader who influences business strategies & shapes tomorrow’s organisations. Join us today & start shaping the future of business & leadership.",
    youtubelink:
      "https://www.youtube.com/embed/BgdE65SZ1SU?start=90&autoplay=1&mute=1&controls=1&modestbranding=1&rel=0",
    bottombgimage: "/image-fix/faculties-message/faculty-of-leadership.jpeg",
    welcometxtbgimage: "/image-fix/faculties-message/faculty-img2.jpeg",
  },
};
